/* Vía Simple · landing de producto (sections/vs-pdp.liquid). */
(function () {
  var top = document.getElementById('vs-top');
  if (!top || top.dataset.ready) return;
  top.dataset.ready = '1';

  var cfg = {};
  try { cfg = JSON.parse(top.dataset.packs || '{}'); } catch (e) {}
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var main = document.querySelector('main') || document.body;

  function money(n) { return '$' + new Intl.NumberFormat('es-CL', { maximumFractionDigits: 0 }).format(Math.round(n)); }
  function num(t) { return Number(String(t || '').replace(/[^0-9]/g, '')) || 0; }
  function form() { return document.getElementById('rsi_form_wrapper'); }
  function goForm(e) {
    var f = form();
    if (!f) return;
    if (e) e.preventDefault();
    f.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }

  /* 1. Cabecera de venta en la ficha: reemplaza el título y el precio de Horizon */
  var details = document.querySelector('.product-details');
  var h1Block = details && details.querySelector('h1');
  var anchor = h1Block && (h1Block.closest('.text-block') || h1Block);
  if (anchor) {
    var group = anchor.parentElement;
    group.insertBefore(top, group.firstChild);
    anchor.classList.add('vs-hide');
  } else if (details) {
    details.insertBefore(top, details.firstChild);
  }
  top.hidden = false;
  document.documentElement.classList.add('vs-pdp-on');

  /* 2. (retirado 2026-10-09) Barra y contador de la campaña Cyber */

  /* 3. Fechas de entrega: Santiago 1 a 3 días hábiles, regiones 2 a 5 */
  function addBusiness(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  var fmt = new Intl.DateTimeFormat('es-CL', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'America/Santiago' });
  var now = new Date();
  var set = function (id, t) { var e = document.getElementById(id); if (e) e.textContent = t; };
  set('vs-d0', fmt.format(now));
  set('vs-d1', fmt.format(addBusiness(now, 1)) + ' – ' + fmt.format(addBusiness(now, 3)));
  set('vs-d2', fmt.format(addBusiness(now, 2)) + ' – ' + fmt.format(addBusiness(now, 5)));

  /* El carrito conserva los cuidados elegidos incluso si hay errores de validación. */

  /* 5. Packs: cinta, título, precio normal tachado y ahorro; actualiza el precio de arriba y el botón fijo */
  var nowEl = document.getElementById('vs-price-now'), oldEl = document.getElementById('vs-price-old');
  var chip = document.getElementById('vs-price-chip'), saveEl = document.getElementById('vs-save');
  var stickyPrice = document.getElementById('vs-sticky-price');
  /* No mostrar un total transitorio ni permitir confirmar otro importe al cambiar de pack. */
  function pricingReady(f) {
    if (!cfg.prices || !cfg.qty) return true;
    var radios = Array.from(f.querySelectorAll('input[name="quantity_offer"]'));
    var index = radios.findIndex(function (radio) { return radio.checked; });
    var total = f.querySelector('.rsi-total-summary-total-value');
    return index >= 0 && !!total && num(total.textContent) === cfg.prices[index];
  }
  function guardPricing(f) {
    if (!cfg.prices) return;
    var ready = pricingReady(f);
    f.classList.toggle('vc-pricing-pending', !ready);
    f.querySelectorAll('.rsi-submit_button,.rsi-additionals_checkout_button').forEach(function (button) {
      if (!ready) button.setAttribute('aria-disabled', 'true');
      else button.removeAttribute('aria-disabled');
    });
    var status = f.querySelector('[data-vc-price-status]');
    if (!status) {
      status = document.createElement('p');
      status.setAttribute('data-vc-price-status', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.className = 'vc-price-status';
      var summary = f.querySelector('.rsi-total-summary-wrapper');
      if (summary) summary.insertAdjacentElement('afterend', status);
    }
    if (status) {
      status.hidden = ready;
      var text = ready ? '' : 'Actualizando el total de tu pack…';
      if (status.textContent !== text) status.textContent = text;
    }
  }
  document.addEventListener('click', function (event) {
    var action = event.target.closest('.rsi-submit_button,.rsi-additionals_checkout_button');
    var f = form();
    if (action && f && !pricingReady(f)) {
      event.preventDefault(); event.stopImmediatePropagation(); guardPricing(f);
    }
  }, true);
  document.addEventListener('submit', function (event) {
    var f = form();
    if (f && f.contains(event.target) && !pricingReady(f)) {
      event.preventDefault(); event.stopImmediatePropagation(); guardPricing(f);
    }
  }, true);
  function decorate(f) {
    f.querySelectorAll('.rsi-total-summary-line-item').forEach(function (li) {
      if (/subtotal|descuento/i.test(li.textContent)) li.classList.add('vs-sum-hide');
    });
    var cards = f.querySelectorAll('label.rsi-quantity-product');
    cards.forEach(function (card, i) {
      var qty = cfg.qty && cfg.qty[i];
      var wrap = card.querySelector('.rsi-quantity-price-wrapper');
      if (!qty || !wrap) return;
      var priceSpan = Array.prototype.find.call(wrap.children, function (el) { return el.tagName === 'SPAN' && !el.classList.contains('rsi-quantity-old-price') && !el.classList.contains('vs-old'); });
      var sale = priceSpan ? num(priceSpan.textContent) : 0;
      if (!sale) return;
      var normal = cfg.normal * qty / cfg.base;
      var pct = normal > sale ? Math.round((normal - sale) / normal * 100) : 0;
      card.classList.add('vs-pack');
      if (cfg.ribbons && cfg.ribbons[i]) card.classList.add('vs-pack--ribbon');
      var key = [sale, i].join('|');
      if (card.dataset.vsKey !== key) {
        card.dataset.vsKey = key;
        card.querySelectorAll('.vs-ribbon,.vs-pack__sub,.vs-old,.vs-pack__meta').forEach(function (e) { e.remove(); });
        var title = card.querySelector('.rsi-quantity-title');
        if (title && cfg.titles) title.textContent = cfg.titles[i];
        if (cfg.ribbons && cfg.ribbons[i]) {
          var r = document.createElement('span'); r.className = 'vs-ribbon'; r.textContent = cfg.ribbons[i];
          card.insertBefore(r, card.firstChild);
        }
        if (title && cfg.subs && cfg.subs[i]) {
          var s = document.createElement('span'); s.className = 'vs-pack__sub'; s.textContent = cfg.subs[i];
          title.insertAdjacentElement('afterend', s);
        }
        if (pct > 0) {
          var o = document.createElement('del'); o.className = 'vs-old'; o.textContent = money(normal);
          wrap.insertBefore(o, wrap.firstChild);
        }
        var meta = document.createElement('div'); meta.className = 'vs-pack__meta';
        meta.innerHTML = (pct > 0 ? '<b>Ahorras ' + money(normal - sale) + ' (-' + pct + '%)</b>' : '') + '<span>' + money(sale / qty) + ' por ' + cfg.unit + '</span>';
        var cont = card.querySelector('.rsi-quantity-price-container') || wrap.parentElement;
        cont.insertAdjacentElement('afterend', meta);
      }
      var input = card.querySelector('input[type=radio]');
      if (input && input.checked) {
        var packLabel = document.getElementById('vs-balm-pack-label');
        var packBadge = document.getElementById('vs-balm-pack-badge');
        if (packLabel && packLabel.textContent !== 'Pack de ' + qty + ' bálsamos') packLabel.textContent = 'Pack de ' + qty + ' bálsamos';
        if (packBadge) packBadge.hidden = qty !== 2;
        if (nowEl.textContent !== money(sale)) nowEl.textContent = money(sale);
        if (stickyPrice && stickyPrice.textContent !== money(sale)) stickyPrice.textContent = money(sale);
        var oldText = pct > 0 ? money(normal) : '';
        if (oldEl.textContent !== oldText) oldEl.textContent = oldText;
        chip.hidden = !pct;
        var chipText = '-' + pct + '% OFF';
        if (chip.textContent !== chipText) chip.textContent = chipText;
        var savingText = (top.dataset.vsProduct === 'balsamo' ? '' : '✅ ') + 'Ahorras ' + money(normal - sale) + ' con ' + (cfg.titles ? cfg.titles[i] : 'este pack');
        saveEl.hidden = !pct; if (saveEl.textContent !== savingText) saveEl.textContent = savingText;
      }
    });
  }

  /* Bálsamo: una acción principal. No mover los botones que administra Releasit. */
  var cardPaymentOpen = false;
  function simplifyPayment(f) {
    if (!top.dataset.cardLabel) return;
    var codLabel = f.querySelector('.rsi-submit_button .rsi-custom-button-content > span');
    if (codLabel && top.dataset.codLabel && codLabel.textContent !== top.dataset.codLabel) {
      codLabel.textContent = top.dataset.codLabel;
    }
    var cardButton = f.querySelector('.rsi-additionals_checkout_button');
    if (!cardButton || !top.dataset.cardLabel) return;
    // Releasit mantiene el descuento real del 5%; aquí solo se expresa en pesos.
    var cardLabel = cardButton.querySelector('.rsi-custom-button-content > span');
    var saving = money(num(nowEl.textContent) * 0.05);
    var cardText = (top.dataset.cardButtonLabel || '').replace('[ahorro]', saving);
    if (cardLabel && cardText && cardLabel.textContent !== cardText) cardLabel.textContent = cardText;
    var row = cardButton.parentElement;
    row.classList.add('vs-card-payment');
    if (!cardButton.id) cardButton.id = 'vs-card-payment-action';
    var toggle = row.querySelector('.vs-card-payment__toggle');
    if (!toggle) {
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'vs-card-payment__toggle';
      toggle.textContent = top.dataset.cardLabel;
      toggle.setAttribute('aria-expanded', String(cardPaymentOpen));
      toggle.setAttribute('aria-controls', cardButton.id);
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        cardPaymentOpen = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(cardPaymentOpen));
      });
      // Evita que el atajo Enter del formulario envíe el pedido al desplegar.
      toggle.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          toggle.click();
        }
      });
      row.insertBefore(toggle, cardButton);
    }
    if (toggle.getAttribute('aria-controls') !== cardButton.id) toggle.setAttribute('aria-controls', cardButton.id);
  }

  /* 6. Errores del formulario: bajar al primer campo con error, enfocarlo y marcarlo */
  var lastScroll = 0;
  function firstError(f) {
    var rows = f.querySelectorAll('.rsi-text-input-error-row, .rsi-select-error-row');
    for (var i = 0; i < rows.length; i++) { if (rows[i].textContent.trim()) return rows[i]; }
    return null;
  }
  function showError() {
    var f = form(); if (!f) return;
    var row = firstError(f); if (!row) return;
    if (Date.now() - lastScroll < 800) return;
    lastScroll = Date.now();
    var field = row.closest('.rsi-text-input-wrapper, .rsi-select-wrapper') || row.parentElement;
    field.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    field.classList.remove('vs-shake'); void field.offsetWidth; field.classList.add('vs-shake');
    var input = field.querySelector('input, select');
    if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, reduce ? 0 : 450);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.rsi-submit_button')) { setTimeout(showError, 250); setTimeout(showError, 900); }
  }, true);

  /* 7. Galería: sin scroll vertical propio (el dedo debe mover la página) y foto principal de la marca
     (2026-10-09: reemplaza las imágenes vs-hero2 con sellos de la campaña Cyber por assets/vs-hero3-*) */
  function fitGallery() {
    var scroller = document.querySelector('media-gallery slideshow-slides');
    if (!scroller) return;
    scroller.style.overflowY = 'hidden';
    var hero = top.dataset.hero;
    if (hero) {
      document.querySelectorAll('media-gallery img[src*="vs-hero2"], media-gallery img[srcset*="vs-hero2"], #rsi_form_wrapper img[src*="vs-hero2"]').forEach(function (img) {
        img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = hero;
      });
    }
  }

  /* Observa los cambios de Releasit (re-renderiza al cambiar de pack) */
  var pending = false;
  var after = document.getElementById('vs-after');
  function refresh() {
    pending = false;
    var f = form();
    if (f) {
      decorate(f);
      simplifyPayment(f);
      guardPricing(f);
      if (after && f.nextElementSibling !== after) { f.insertAdjacentElement('afterend', after); after.hidden = false; }
    }
    fitGallery();
    updateSticky();
  }
  new MutationObserver(function () { if (!pending) { pending = true; setTimeout(refresh, 80); } })
    .observe(document.body, { childList: true, subtree: true, characterData: true });
  document.addEventListener('change', function (e) { if (e.target.closest('#rsi_form_wrapper')) setTimeout(refresh, 120); });
  refresh();

  /* 8. Botones que llevan al formulario y botón fijo abajo */
  document.querySelectorAll('.vs-js-goform').forEach(function (a) { a.addEventListener('click', goForm); });
  var sticky = document.getElementById('vs-sticky');
  function updateSticky() {
    var f = form(); if (!f || !sticky) return;
    var r = f.getBoundingClientRect();
    var formVisible = r.top < innerHeight && r.bottom > 0;
    sticky.classList.toggle('on', !formVisible);
  }
  window.addEventListener('scroll', updateSticky, { passive: true });
  document.addEventListener('scroll', updateSticky, { passive: true, capture: true });
  window.addEventListener('resize', updateSticky, { passive: true });
  updateSticky();
})();
